import { useCallback, useEffect, useState } from 'react';

/** A countdown in whole seconds, such as the wait imposed by a rate limit. */
export function useCooldown() {
  // `now` is state rather than read during render, which keeps rendering pure.
  const [span, setSpan] = useState<{ until: number; now: number } | null>(null);
  const secondsLeft = span ? Math.max(0, Math.ceil((span.until - span.now) / 1000)) : 0;
  const active = secondsLeft > 0;

  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => {
      const now = Date.now();
      setSpan((current) => current && { ...current, now });
    }, 250);
    return () => {
      clearInterval(timer);
    };
  }, [active]);

  const start = useCallback((seconds: number) => {
    const now = Date.now();
    setSpan({ until: now + seconds * 1000, now });
  }, []);

  return { secondsLeft, start };
}
